module.exports = __webpack_public_path__ + "static/media/desk-office-icon--hover.de9f6644.svg";